import ApplicationController from './application_controller';

// Toggles between a signer's saved signature and the "draw a new one" pad on the
// sign-by-link page.
//
// The <signature-pad> element sizes its canvas on connect from its parent's
// dimensions, so it can't be rendered hidden (it'd be 0x0 and unsignable).
// Instead the pad markup lives in an inert <template>; revealing INJECTS it, so
// it connects while visible and sizes correctly — exactly like the no-saved
// case. Reverting removes the injected pad (and its fields), so the form falls
// back to the saved signature.
export default class extends ApplicationController {
  static targets = ['pad', 'saved', 'template'];

  reveal(event) {
    event.preventDefault();
    this.padTarget.appendChild(this.templateTarget.content.cloneNode(true));
    this.savedTarget.classList.add('d-none');
  }

  useSaved(event) {
    event.preventDefault();
    this.padTarget.innerHTML = '';
    this.savedTarget.classList.remove('d-none');
  }
}
